import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Procedure } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ProcedureModule extends VuexModule {
    @Action
    [Procedure.getProcedureList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/procedure/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Procedure.findPageProcedure](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/procedure/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Procedure.saveProcedure](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/procedure/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Procedure.deleteProcedure](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/procedure/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}